"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 33: Taito TC0190FMC / TC0350FMR
 * ------------------------------------------------------------------ *
 * Registers (NESdev Wiki + reznez / Mesen cross-check):
 *   $8000 [.mpppppp]  M = bit 6 (0=Vert, 1=Horz), P = PRG Reg 0 (6 bits, 8k @ $8000)
 *   $8001 [..pppppp]  PRG Reg 1 (6 bits, 8k @ $A000) -- mask 0x3F
 *   $8002 [CCCC CCCC]  CHR Reg 0 (2k @ $0000) -- bank = value directly
 *   $8003 [CCCC CCCC]  CHR Reg 1 (2k @ $0800)
 *   $A000 [CCCC CCCC]  CHR Reg 2 (1k @ $1000)
 *   $A001 [CCCC CCCC]  CHR Reg 3 (1k @ $1400)
 *   $A002 [CCCC CCCC]  CHR Reg 4 (1k @ $1800)
 *   $A003 [CCCC CCCC]  CHR Reg 5 (1k @ $1C00)
 *
 * The register block is decoded with address & $A003 over $8000-$BFFF, so a
 * write to $8004 or $9000 hits register 0, exactly like the hardware.
 *
 * PRG setup (all windows are 8 KB):
 *   $8000 = P0 (switchable)
 *   $A000 = P1 (switchable)
 *   $C000 = second-to-last 8 KB bank (fixed)
 *   $E000 = last 8 KB bank (fixed)
 *
 * CHR setup:
 *   $0000-$07FF = C0 (2 KB bank)
 *   $0800-$0FFF = C1 (2 KB bank)
 *   $1000-$13FF = C2 (1 KB bank)
 *   $1400-$17FF = C3 (1 KB bank)
 *   $1800-$1BFF = C4 (1 KB bank)
 *   $1C00-$1FFF = C5 (1 KB bank)
 *
 * No IRQs on mapper 33 (mapper 48 is the TC0690 with the MMC3 timer).
 * ------------------------------------------------------------------ */

function register(Mappers) {
  Mappers[33] = function (nes) {
    this.nes = nes;
    this.mirroring = 0;
    this.prgBank = 0; // P0 (8 KB @ $8000)
    this.prgBank1 = 0; // P1 (8 KB @ $A000)
    this.chrBank0 = 0; // C0 (2 KB @ $0000)
    this.chrBank1 = 0; // C1 (2 KB @ $0800)
    this.chrBank2 = 0; // C2 (1 KB @ $1000)
    this.chrBank3 = 0; // C3 (1 KB @ $1400)
    this.chrBank4 = 0; // C4 (1 KB @ $1800)
    this.chrBank5 = 0; // C5 (1 KB @ $1C00)
  };

  Mappers[33].prototype = new Mappers[0]();
  Mappers[33].prototype.irqClockRate = "none";

  Mappers[33].prototype.reset = function () {
    this.prgBank = 0;
    this.prgBank1 = 0;
    this.chrBank0 = 0;
    this.chrBank1 = 0;
    this.chrBank2 = 0;
    this.chrBank3 = 0;
    this.chrBank4 = 0;
    this.chrBank5 = 0;

    if (this.nes && this.nes.rom && this.nes.rom.getMirroringType) {
      this.setMirroring(this.nes.rom.getMirroringType());
    }
  };

  Mappers[33].prototype.setMirroring = function (mirroring) {
    if (mirroring === this.nes.rom.HORIZONTAL_MIRRORING) {
      this.nes.ppu.setMirroring(this.nes.rom.HORIZONTAL_MIRRORING);
    } else {
      this.nes.ppu.setMirroring(this.nes.rom.VERTICAL_MIRRORING);
    }
    this.mirroring = mirroring;
  };

  Mappers[33].prototype.write = function (address, value) {
    if (address >= 0x8000) {
      if (address <= 0xbfff) {
        // The TC0190 decodes its register block with address & $A003.
        switch (address & 0xa003) {
          case 0x8000:
            // P0 + mirroring (bit 6)
            this.prgBank = value & 0x3f;
            this.setMirroring((value >> 6) & 1);
            this.load8kRomBank(this.prgBank, 0x8000);
            break;
          case 0x8001:
            // P1
            this.prgBank1 = value & 0x3f;
            this.load8kRomBank(this.prgBank1, 0xa000);
            break;
          case 0x8002:
            // C0, 2 KB
            this.chrBank0 = value;
            this.load2kVromBank(value, 0x0000);
            break;
          case 0x8003:
            // C1, 2 KB
            this.chrBank1 = value;
            this.load2kVromBank(value, 0x0800);
            break;
          case 0xa000:
            // C2, 1 KB
            this.chrBank2 = value;
            this.load1kVromBank(value, 0x1000);
            break;
          case 0xa001:
            // C3, 1 KB
            this.chrBank3 = value;
            this.load1kVromBank(value, 0x1400);
            break;
          case 0xa002:
            // C4, 1 KB
            this.chrBank4 = value;
            this.load1kVromBank(value, 0x1800);
            break;
          case 0xa003:
            // C5, 1 KB
            this.chrBank5 = value;
            this.load1kVromBank(value, 0x1c00);
            break;
          default:
            break;
        }
      }
      // $C000-$FFFF are the fixed PRG banks: a write reaches no register and
      // must not fall through to NROM, which would overwrite the ROM copy.
      return;
    }

    // Everything else (work RAM, PPU/APU registers, cartridge WRAM) is the
    // NROM path.
    Mappers[0].prototype.write.apply(this, arguments);
  };

  // Re-derives every window from the registers.
  Mappers[33].prototype.updateBanks = function () {
    var rom = this.nes.rom;
    if (!rom || !rom.rom || rom.rom.length === 0) {
      return;
    }

    // Switchable 8 KB windows.
    this.load8kRomBank(this.prgBank, 0x8000);
    this.load8kRomBank(this.prgBank1, 0xa000);

    // $C000 + $E000 are the last two 8 KB banks, i.e. the last 16 KB bank.
    this.loadRomBank(rom.romCount - 1, 0xc000);

    // CHR windows (if the cartridge carries CHR-ROM).
    if (rom.vrom && rom.vrom.length > 0) {
      this.load2kVromBank(this.chrBank0, 0x0000);
      this.load2kVromBank(this.chrBank1, 0x0800);
      this.load1kVromBank(this.chrBank2, 0x1000);
      this.load1kVromBank(this.chrBank3, 0x1400);
      this.load1kVromBank(this.chrBank4, 0x1800);
      this.load1kVromBank(this.chrBank5, 0x1c00);
    }
  };

  Mappers[33].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Mapper 33: Invalid ROM! Unable to load.");
    }

    this.reset();

    // Power-on register values are 0 on this board: P0/P1 = 0, all CHR = 0.
    this.updateBanks();

    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };

  Mappers[33].prototype.toJSON = function () {
    return {
      mirroring: this.mirroring,
      prgBank: this.prgBank,
      prgBank1: this.prgBank1,
      chrBank0: this.chrBank0,
      chrBank1: this.chrBank1,
      chrBank2: this.chrBank2,
      chrBank3: this.chrBank3,
      chrBank4: this.chrBank4,
      chrBank5: this.chrBank5,
    };
  };

  Mappers[33].prototype.fromJSON = function (s) {
    if (s.mirroring !== undefined) this.setMirroring(s.mirroring);
    if (s.prgBank !== undefined) this.prgBank = s.prgBank;
    if (s.prgBank1 !== undefined) this.prgBank1 = s.prgBank1;
    if (s.chrBank0 !== undefined) this.chrBank0 = s.chrBank0;
    if (s.chrBank1 !== undefined) this.chrBank1 = s.chrBank1;
    if (s.chrBank2 !== undefined) this.chrBank2 = s.chrBank2;
    if (s.chrBank3 !== undefined) this.chrBank3 = s.chrBank3;
    if (s.chrBank4 !== undefined) this.chrBank4 = s.chrBank4;
    if (s.chrBank5 !== undefined) this.chrBank5 = s.chrBank5;
    // The CPU/PPU copies are not part of the save state: rebuild them.
    this.updateBanks();
  };
}

module.exports = { register: register };
